export const EmailIcon = () => {
  return (
    <svg
      stroke="#336DC4"
      fill="#336DC4"
      strokeWidth="0.3"
      version="1.1"
      viewBox="0 0 17 17"
      height="20px"
      width="1em">
      <g></g>
      <path
        d="M0 2v13h17v-13h-17zM8.494 9.817l-6.896-6.817h13.82l-6.924 6.817zM5.755 8.516l-4.755 4.682v-9.383l4.755 4.701zM6.466 9.219l2.026 2.003 1.996-1.966 4.8 4.744h-13.677l4.855-4.781zM11.201 8.555l4.799-4.725v9.467l-4.799-4.742z"></path>
    </svg>
  );
};